import { gsap } from 'gsap';
import { $window } from '../../helpers/globalVars';

const handler = ( $ ) => {
	const $body = $( 'body' ),
		$header = $( '.header' ),
		$menuLink = $( '.header-nav__link', $header ),
		$panelOpener = $( '[data-is-open-panel="yes"]', $header ),
		$panel = $( '[data-type="panel"]', $header ),
		$desktopPanel = $panel.filter( '.header__desktop-panel' ),
		$mobilePanel = $panel.filter( '.mobile-panel' ),
		$mobilePanelBody = $( '.mobile-panel__body', $mobilePanel ),
		$tabsItem = $( '.header-tabs__item', $desktopPanel ),
		$tabsLink = $( '.header-tabs__link', $tabsItem ),
		$tabsLinkHasTab = $tabsLink.filter( '[data-has-tab="yes"]' ),
		$tabsBody = $( '.header-tabs__body', $desktopPanel ),
		$navWrapper = $( '.header-tabs__wrapper', $desktopPanel ),
		$desktopSearchInput = $( '.search-form__input', $desktopPanel ),
		$mobileSearchInput = $( '.search-form__input', $mobilePanel ),
		$hamburger = $( '.header__hamburger', $header ),
		$cross = $( '.cross', $mobilePanel ),
		$mobileMenuIconSearch = $( '.header__icon-search--mobile', $header ),
		$mobilePanelIconSearch = $( '.icon-search', $mobilePanel ),
		$mobilePanelSearchPanel = $( '.mobile-panel__search-panel' );

	const generatePanelSubMenu = ( $menu ) => {
		const $subMenu = $( '.sub-menu', $menu );

		$navWrapper.html( '' );

		$subMenu.each( function ( index, subMenu ) {
			const $navLabel = $( document.createElement( 'div' ) )
				.addClass( 'header-tabs-nav__label' )
				.text( $( '>li>a', $menu ).eq( index ).text() );

			const $subMenuClone = $( subMenu ).clone(),
				$subMenuCloneLink = $( '>li>a', $subMenuClone );

			$subMenuClone.attr( 'class', 'header-tabs-nav__list' );
			$subMenuCloneLink.attr(
				'class',
				'link link--hover_arrow header-tabs-nav__link'
			);

			const $nav = $( document.createElement( 'nav' ) )
				.addClass( 'header-tabs-nav header-tabs__nav' )
				.append( $navLabel )
				.append( $subMenuClone );

			$navWrapper.append( $nav );
		} );
	};

	const activateTab = ( refLink ) => {
		const activeLinkClass = 'header-tabs__link--is-active',
			visibleBodyClass = 'is-visible',
			dataLinkBg = $( refLink ).attr( 'data-background' ),
			$newActiveTabsBody = $tabsBody.filter(
				`.header-tabs__body--${ dataLinkBg }`
			),
			$refLink = $( refLink );

		$tabsBody.removeClass( visibleBodyClass );
		$newActiveTabsBody.addClass( visibleBodyClass );
		$tabsLink.removeClass( activeLinkClass );

		if ( $refLink.attr( 'data-is-tab-search' ) == 'yes' ) {
			$refLink.addClass( activeLinkClass );
			$desktopSearchInput.trigger( 'focus' );
		} else if ( $refLink.attr( 'data-is-menu-search' ) == 'yes' ) {
			$( '[data-is-tab-search="yes"]' ).addClass( activeLinkClass );
			$desktopSearchInput.trigger( 'focus' );
		} else if ( $refLink.attr( 'data-has-tab' ) == 'yes' ) {
			$refLink.addClass( activeLinkClass );
			generatePanelSubMenu( $refLink.next() );
		} else {
			$menuLink.each( function ( index, menuLinkEl ) {
				if ( menuLinkEl == refLink ) {
					$tabsLink.eq( index ).addClass( activeLinkClass );

					generatePanelSubMenu( $tabsLink.eq( index ).next() );

					return false;
				}
			} );
		}
	};

	const showPanel = ( $panel ) => {
		if ( $panel.hasClass( 'mobile-panel' ) ) {
			$mobilePanelBody.show();
			$body.css( 'overflow', 'hidden' );
		}

		gsap.to( $panel, {
			keyframes: [
				{ y: 20, ease: 'power2.out', duration: 0.5 },
				{ y: 0, duration: 0.3 },
			],
			onComplete: () => {
				$panel.attr( 'data-is-visible', 'yes' );
			},
		} );
	};

	const hidePanel = ( $panel ) => {
		gsap.to( $panel, {
			y: '-100%',
			ease: 'power2.out',
			duration: 0.3,
			onComplete: () => {
				$panel.attr( 'data-is-visible', 'no' );
			},
		} );

		$body.css( 'overflow', 'auto' );

		$mobilePanelSearchPanel.hide();
	};

	const menuLinkDropdownHoverInHandler = function ( e ) {
		e.preventDefault();

		activateTab( this );
		showPanel( $desktopPanel );
	};

	const windowClickHandler = ( e ) => {
		const $visiblePanel = $panel.filter( '[data-is-visible="yes"]' ),
			isPanelOutClick =
				! $panel.is( e.target ) && $panel.has( e.target ).length == 0,
			isPanelOpenerOutClick =
				! $panelOpener.is( e.target ) &&
				$panelOpener.has( e.target ).length == 0;

		if (
			isPanelOutClick &&
			$visiblePanel.length &&
			isPanelOpenerOutClick
		) {
			hidePanel( $visiblePanel );
		}
	};

	const tabsLinkHandler = function ( e ) {
		e.preventDefault();

		activateTab( this );
	};

	const hamburgerClickHandler = function () {
		showPanel( $mobilePanel );
	};

	const crossClickHandler = () => {
		hidePanel( $mobilePanel );
	};

	const mobileMenuIconSearchClickHandler = () => {
		showPanel( $mobilePanel );

		$mobilePanelBody.hide();
		$mobilePanelSearchPanel.show();

		$mobileSearchInput.trigger( 'focus' );
	};

	const mobilePanelIconSearchClickHandler = () => {
		$mobilePanelBody.hide();
		$mobilePanelSearchPanel.show();

		$mobileSearchInput.trigger( 'focus' );
	};

	$panelOpener.on( 'click', menuLinkDropdownHoverInHandler );
	$window.on( 'click', windowClickHandler );
	$tabsLinkHasTab.on( 'click', tabsLinkHandler );
	$hamburger.on( 'click', hamburgerClickHandler );
	$cross.on( 'click', crossClickHandler );
	$mobileMenuIconSearch.on( 'click', mobileMenuIconSearchClickHandler );
	$mobilePanelIconSearch.on( 'click', mobilePanelIconSearchClickHandler );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
